import {
  BULK_DELETE_BUSINESS_ABORT_PROCESS,
  BULK_DELETE_BUSINESS_CONFIRM_PROCESS_RESPOND,
  BULK_DELETE_BUSINESS_DO_SHOW_LOG,
  BULK_DELETE_BUSINESS_INITIALIZE_PROCESS_STATE,
  BULK_DELETE_BUSINESS_LOG_CHANGE_PAGE,
  BULK_DELETE_BUSINESS_LOG_SET_DATA,
  BULK_DELETE_BUSINESS_LOG_SET_ERRORS,
  BULK_DELETE_BUSINESS_LOG_SET_IS_LOADING,
  BULK_DELETE_BUSINESS_LOG_SET_SHOWN,
  BULK_DELETE_BUSINESS_PREPEND_BUSINESS_ERROR,
  BULK_DELETE_BUSINESS_SET_CURRENT_BUSINESS_ID,
  BULK_DELETE_BUSINESS_SET_GLOBAL_ERROR,
  BULK_DELETE_BUSINESS_SET_IS_PROCESSING,
  BULK_DELETE_BUSINESS_SET_PROCESS_STATUS,
  BULK_DELETE_BUSINESS_SET_PROCESSED_COUNT,
  BULK_DELETE_BUSINESS_SHOW_CONFIRM_PROCESS_MODAL,
  DO_BULK_DELETE_BUSINESS,
} from 'state/actionTypes';

export const setIsProcessing = isProcessing => ({
  type: BULK_DELETE_BUSINESS_SET_IS_PROCESSING,
  payload: { isProcessing },
});

export const initializeProcessState = businessIds => ({
  type: BULK_DELETE_BUSINESS_INITIALIZE_PROCESS_STATE,
  payload: { businessIds },
});

export const setProcessedCount = processed => ({
  type: BULK_DELETE_BUSINESS_SET_PROCESSED_COUNT,
  payload: { processed },
});

export const doBulkDeleteBusiness = businessIds => ({
  type: DO_BULK_DELETE_BUSINESS,
  payload: { businessIds },
});

export const prependBusinessError = (businessId, messages) => ({
  type: BULK_DELETE_BUSINESS_PREPEND_BUSINESS_ERROR,
  payload: { businessId, messages },
});

export const setProcessStatus = status => ({
  type: BULK_DELETE_BUSINESS_SET_PROCESS_STATUS,
  payload: { status },
});

export const setCurrentBusinessId = businessId => ({
  type: BULK_DELETE_BUSINESS_SET_CURRENT_BUSINESS_ID,
  payload: { businessId },
});

export const abortProcess = () => ({
  type: BULK_DELETE_BUSINESS_ABORT_PROCESS,
});

export const showConfirmProcessModal = () => ({
  type: BULK_DELETE_BUSINESS_SHOW_CONFIRM_PROCESS_MODAL,
});

export const confirmProcess = proceed => ({
  type: BULK_DELETE_BUSINESS_CONFIRM_PROCESS_RESPOND,
  payload: { proceed },
});

export const setLogModalShown = shown => ({
  type: BULK_DELETE_BUSINESS_LOG_SET_SHOWN,
  payload: { shown },
});

export const doShowLogs = () => ({
  type: BULK_DELETE_BUSINESS_DO_SHOW_LOG,
});

export const setLogPage = page => ({
  type: BULK_DELETE_BUSINESS_LOG_CHANGE_PAGE,
  payload: { page },
});

export const setLogData = (data, paging) => ({
  type: BULK_DELETE_BUSINESS_LOG_SET_DATA,
  payload: { data, paging },
});

export const resetLogData = () =>
  setLogData([], { page: 1, size: 20, total: 0 });

export const setLogIsLoading = isLoading => ({
  type: BULK_DELETE_BUSINESS_LOG_SET_IS_LOADING,
  payload: { isLoading },
});

export const setLogErrors = errors => ({
  type: BULK_DELETE_BUSINESS_LOG_SET_ERRORS,
  payload: { errors },
});

export const clearLogErrors = () => setLogErrors([]);

export const setGlobalError = error => ({
  type: BULK_DELETE_BUSINESS_SET_GLOBAL_ERROR,
  payload: { error },
});
